import React from "react";
import { useNavigate } from "react-router-dom";

function GiftsDemoPage() {
  const navigate = useNavigate();

  return (
    <div className="gifts-page">
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Retour
      </button>

      <div className="grid-bg"></div>
      <div className="glow glow-top"></div>
      <div className="glow glow-bottom"></div>

      <div className="live-card">
        <div className="live-badge">LIVE</div>

        <div className="creator-circle">
          <span>🎥</span>
        </div>

        <h2>@créateur_evo</h2>
        <p>Live en cours • communauté active</p>

        <div className="gift-stream">
          <div className="gift gift-1">🎁</div>
          <div className="gift gift-2">💎</div>
          <div className="gift gift-3">⚡</div>
          <div className="gift gift-4">🔥</div>
          <div className="gift gift-5">⭐</div>
        </div>

        <div className="gift-bar">
          <button>🎁 Cadeau</button>
          <button>💎 Diamond</button>
          <button>⚡ Boost</button>
        </div>
      </div>

      <div className="content">
        <p className="label">EVO GIFTS</p>

        <h1>Cadeaux virtuels</h1>

        <p>
          Les spectateurs peuvent envoyer des cadeaux pendant les lives,
          mais aussi sous les vidéos pour remercier un créateur et valoriser
          son contenu.
        </p>

        <div className="mini-stats">
          <div>
            <strong>LIVE</strong>
            <span>Cadeaux en direct</span>
          </div>

          <div>
            <strong>VIDÉOS</strong>
            <span>Soutien sous contenu</span>
          </div>

          <div>
            <strong>EVO</strong>
            <span>Créateurs valorisés</span>
          </div>
        </div>
      </div>

      <style>{`
        .gifts-page {
          position: fixed;
          inset: 0;
          overflow: hidden;
          background:
            radial-gradient(circle at top right, rgba(0,242,255,0.22), transparent 34%),
            radial-gradient(circle at bottom left, rgba(0,145,255,0.16), transparent 34%),
            linear-gradient(135deg, #02040a 0%, #03131d 48%, #02040a 100%);
          color: white;
          font-family: Arial, sans-serif;
        }

        .back-btn {
          position: absolute;
          top: 22px;
          left: 22px;
          z-index: 20;
          border: 1px solid rgba(0,242,255,0.55);
          background: rgba(0, 12, 20, 0.9);
          color: #00f2ff;
          padding: 11px 18px;
          border-radius: 16px;
          font-weight: 900;
          cursor: pointer;
          box-shadow: 0 0 20px rgba(0,242,255,0.35);
        }

        .grid-bg {
          position: absolute;
          inset: 0;
          opacity: 0.13;
          background-image:
            linear-gradient(rgba(0,242,255,0.18) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0,242,255,0.18) 1px, transparent 1px);
          background-size: 42px 42px;
          animation: gridMove 18s linear infinite;
        }

        .glow {
          position: absolute;
          width: 360px;
          height: 360px;
          border-radius: 50%;
          filter: blur(85px);
          background: #00f2ff;
          opacity: 0.35;
          animation: glowFloat 5s ease-in-out infinite alternate;
        }

        .glow-top {
          top: -110px;
          left: 18%;
        }

        .glow-bottom {
          bottom: -130px;
          right: 10%;
          opacity: 0.25;
          animation-delay: 1.2s;
        }

        .live-card {
          position: absolute;
          left: 8%;
          top: 50%;
          transform: translateY(-50%);
          width: 360px;
          height: 600px;
          border-radius: 42px;
          background:
            radial-gradient(circle at top, rgba(0,242,255,0.20), transparent 35%),
            rgba(0, 12, 20, 0.88);
          border: 1px solid rgba(0,242,255,0.35);
          box-shadow:
            0 0 45px rgba(0,242,255,0.28),
            inset 0 0 32px rgba(0,242,255,0.08);
          overflow: hidden;
          text-align: center;
          animation: phoneIn 0.9s ease forwards;
        }

        .live-card::before {
          content: "";
          position: absolute;
          top: 14px;
          left: 50%;
          transform: translateX(-50%);
          width: 95px;
          height: 8px;
          border-radius: 20px;
          background: rgba(255,255,255,0.28);
        }

        .live-badge {
          position: absolute;
          top: 38px;
          left: 28px;
          padding: 7px 13px;
          border-radius: 999px;
          background: rgba(0,242,255,0.12);
          border: 1px solid rgba(0,242,255,0.55);
          color: #00f2ff;
          font-size: 13px;
          font-weight: 900;
          box-shadow: 0 0 18px rgba(0,242,255,0.35);
          animation: livePulse 1.4s ease-in-out infinite;
        }

        .creator-circle {
          width: 135px;
          height: 135px;
          border-radius: 50%;
          margin: 92px auto 18px;
          border: 2px solid rgba(0,242,255,0.65);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 0 35px rgba(0,242,255,0.45);
          position: relative;
          animation: circlePulse 2s ease-in-out infinite;
        }

        .creator-circle::after {
          content: "";
          position: absolute;
          width: 135px;
          height: 135px;
          border-radius: 50%;
          border: 1px solid rgba(0,242,255,0.35);
          animation: wave 2s linear infinite;
        }

        .creator-circle span {
          font-size: 52px;
          filter: drop-shadow(0 0 16px rgba(0,242,255,0.7));
        }

        .live-card h2 {
          margin: 0;
          font-size: 25px;
          text-shadow: 0 0 18px rgba(0,242,255,0.5);
        }

        .live-card p {
          margin: 10px 28px 0;
          color: #9befff;
          font-size: 15px;
          line-height: 1.5;
        }

        .gift-stream {
          position: absolute;
          inset: 0;
          pointer-events: none;
        }

        .gift {
          position: absolute;
          bottom: 88px;
          font-size: 34px;
          opacity: 0;
          filter: drop-shadow(0 0 16px rgba(0,242,255,0.8));
          animation: giftFly 4s ease-in-out infinite;
        }

        .gift-1 {
          left: 62px;
          animation-delay: 0s;
        }

        .gift-2 {
          left: 132px;
          animation-delay: 0.7s;
        }

        .gift-3 {
          right: 92px;
          animation-delay: 1.4s;
        }

        .gift-4 {
          right: 45px;
          animation-delay: 2.1s;
        }

        .gift-5 {
          left: 95px;
          animation-delay: 2.8s;
        }

        .gift-bar {
          position: absolute;
          left: 18px;
          right: 18px;
          bottom: 24px;
          display: flex;
          gap: 8px;
          justify-content: center;
        }

        .gift-bar button {
          flex: 1;
          border: 1px solid rgba(0,242,255,0.35);
          background: rgba(0,242,255,0.10);
          color: #dffcff;
          padding: 12px 8px;
          border-radius: 16px;
          font-size: 12px;
          font-weight: 900;
          box-shadow: 0 0 18px rgba(0,242,255,0.12);
        }

        .content {
          position: absolute;
          right: 8%;
          top: 50%;
          transform: translateY(-50%);
          max-width: 560px;
          animation: textIn 1s ease forwards;
        }

        .label {
          color: #00f2ff;
          font-weight: 900;
          letter-spacing: 4px;
          margin-bottom: 14px;
        }

        .content h1 {
          font-size: 58px;
          line-height: 1;
          margin: 0 0 22px;
          text-shadow: 0 0 35px rgba(0,242,255,0.65);
        }

        .content p {
          color: #bdefff;
          font-size: 20px;
          line-height: 1.65;
          margin-bottom: 30px;
        }

        .mini-stats {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 14px;
        }

        .mini-stats div {
          padding: 18px;
          border-radius: 22px;
          background: rgba(0, 12, 20, 0.78);
          border: 1px solid rgba(0,242,255,0.28);
          box-shadow: 0 0 22px rgba(0,242,255,0.12);
          animation: statFloat 2.8s ease-in-out infinite;
        }

        .mini-stats div:nth-child(2) {
          animation-delay: 0.3s;
        }

        .mini-stats div:nth-child(3) {
          animation-delay: 0.6s;
        }

        .mini-stats strong {
          display: block;
          color: #ffffff;
          font-size: 17px;
          margin-bottom: 8px;
        }

        .mini-stats span {
          color: #9befff;
          font-size: 13px;
          line-height: 1.35;
        }

        @keyframes giftFly {
          0% {
            opacity: 0;
            transform: translateY(0) scale(0.6) rotate(-8deg);
          }
          15% {
            opacity: 1;
          }
          55% {
            opacity: 1;
            transform: translateY(-230px) scale(1.15) rotate(8deg);
          }
          100% {
            opacity: 0;
            transform: translateY(-380px) scale(0.85) rotate(0deg);
          }
        }

        @keyframes wave {
          0% {
            transform: scale(1);
            opacity: 0.8;
          }
          100% {
            transform: scale(2.2);
            opacity: 0;
          }
        }

        @keyframes livePulse {
          0%, 100% {
            box-shadow: 0 0 12px rgba(0,242,255,0.25);
          }
          50% {
            box-shadow: 0 0 30px rgba(0,242,255,0.85);
          }
        }

        @keyframes circlePulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.06);
          }
        }

        @keyframes statFloat {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-8px);
          }
        }

        @keyframes phoneIn {
          from {
            opacity: 0;
            transform: translateY(-50%) translateX(-80px) scale(0.92);
          }
          to {
            opacity: 1;
            transform: translateY(-50%) translateX(0) scale(1);
          }
        }

        @keyframes textIn {
          from {
            opacity: 0;
            transform: translateY(-42%);
          }
          to {
            opacity: 1;
            transform: translateY(-50%);
          }
        }

        @keyframes gridMove {
          from {
            background-position: 0 0;
          }
          to {
            background-position: 84px 84px;
          }
        }

        @keyframes glowFloat {
          from {
            transform: translateY(0) scale(1);
          }
          to {
            transform: translateY(-35px) scale(1.12);
          }
        }

        @media (max-width: 900px) {
          .live-card {
            left: 50%;
            top: 39%;
            transform: translate(-50%, -50%);
            width: 285px;
            height: 455px;
            border-radius: 34px;
          }

          .creator-circle {
            width: 100px;
            height: 100px;
            margin-top: 72px;
          }

          .creator-circle::after {
            width: 100px;
            height: 100px;
          }

          .creator-circle span {
            font-size: 40px;
          }

          .gift-bar {
            bottom: 18px;
          }

          .gift-bar button {
            font-size: 10px;
            padding: 10px 5px;
          }

          .content {
            left: 22px;
            right: 22px;
            top: auto;
            bottom: 28px;
            transform: none;
            text-align: center;
          }

          .content h1 {
            font-size: 36px;
          }

          .content p {
            font-size: 16px;
          }

          .mini-stats {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
}

export default GiftsDemoPage;
